import { ethers } from "ethers";
import { createContract } from "../utils/createContract";

export const approveContract = (
  library: any,
  spender: string,
  spent: string,
  abi?: any
) => {
  const contract = createContract(abi, library, spent);

  if (!contract) return;

  return contract
    .approve(spender, ethers.constants.MaxUint256)
    .then((response) => {
      console.debug("Approve transaction sent successfully");
      return response.wait().then((response) => {
        console.debug(`Transaction ${response.transactionHash} confirmed`);
        return response;
      });
    });
};
